export const isOverflowing = (element) => element && element.offsetWidth < element.scrollWidth;
